import PositioningDeviceFittingChangeInstallerModal from './positioningdevicefitting-change-installer-modal.vue'
export default PositioningDeviceFittingChangeInstallerModal
